import styled from 'styled-components';
import breakpoint from '~/utils/style-utils';

const JackpotContainer = styled.div`
	border-radius: 0 0 12px 12px;
	position: absolute;
	height: 22px;
	width: 100%;
	bottom: 0;
	overflow: hidden;

	${breakpoint.lg`
		height: 30px;
	`};
`;

const JackpotBackground = styled.div`
	background: rgba(0, 0, 0, 0.5);
	backdrop-filter: blur(2rem);
	mix-blend-mode: overlay;
	height: 100%;
	width: 100%;
`;

const JackpotLabel = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
`;

const JackpotText = styled.p`
	font: var(--gameCardJackpotFontSmall);
	color: var(--gameCardJackpotText);

	${breakpoint.lg`
		font: var(--gameCardJackpotFont);
	`};
`;

const GameJackpot = ({ text }) => {
	return (
		<JackpotContainer>
			<JackpotBackground />
			<JackpotLabel data-at="jackpot-ticker">
				<JackpotText>{text}</JackpotText>
			</JackpotLabel>
		</JackpotContainer>
	);
};

export default GameJackpot;
